export default __webpack_public_path__ + "static/media/badge_icon_1.9798b8be.svg";